import styled from "styled-components";

import { HousingRule } from "../../../constants/housingRules";

type HousingRuleTextProps = {
    className?: string;
    rule: HousingRule | string;
};

const HousingRuleText = ({
    className = "",
    rule,
}: HousingRuleTextProps): JSX.Element => {
    switch (rule) {
        case HousingRule.PARAGRAPH_5A:
            return (
                <Item className={className} marker="5(a).">
                    The payment of property tax levied in respect of the land on
                    which the building project is carried.
                </Item>
            );
        case HousingRule.PARAGRAPH_5B:
            return (
                <Item className={className} marker="5(b).">
                    The payment of stamp duty payable on a mortgage to secure
                    any loan for construction of the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5C:
            return (
                <Item className={className} marker="5(c).">
                    The payment of legal fees in respect of:
                    <Item marker="i.">
                        the sale and purchase of the units in the building
                        project
                    </Item>
                    <Item marker="ii.">
                        any mortgage to secure loans for construction of the
                        units in the building project
                    </Item>
                    <Item marker="iii.">
                        any other matters relating to the building project
                    </Item>
                </Item>
            );
        case HousingRule.PARAGRAPH_5D:
            return (
                <Item className={className} marker="5(d).">
                    The payment of insurance premiums, architect's fee,
                    engineer's ees, quantity surveyor's fees and consultant's
                    fees for the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5E:
            return (
                <Item className={className} marker="5(e).">
                    The cost of carrying out:
                    <Item marker="i.">foundation works</Item>
                    <Item marker="ii.">soil investigation</Item>
                    <Item marker="iii.">earth works</Item>
                    <Item marker="iv.">providing site supervision</Item>
                </Item>
            );
        case HousingRule.PARAGRAPH_5F:
            return (
                <Item className={`mb-3 ${className}`} marker="5(f).">
                    The payment of money for the supply electricity and water
                    and installation charges and other fees and deposit to
                    Public Utilities Board.
                </Item>
            );
        case HousingRule.PARAGRAPH_5G:
            return (
                <Item className={className} marker="5(g).">
                    The payment of deposits and charges, other than development
                    charges, payable to the Commissioner of Buildings and any
                    Government department or statutory body in respect of the
                    building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5H:
            return (
                <Item className={className} marker="5(h).">
                    Any refund of booking fee or progress payments pursuant to
                    any agreement for the sale and purchase of any unit in the
                    building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5I:
            return (
                <Item className={className} marker="5(i).">
                    The payment of the cost of construction of the building
                    project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5J:
            return (
                <Item className={className} marker="5(j).">
                    The payment of interest and other charges on any loan for
                    the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5K:
            return (
                <Item className={className} marker="5(k).">
                    The payment of any capital sum redeem in full or partially
                    any loan for the construction of the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5L:
            return (
                <Item className={className} marker="5(l).">
                    The payment of any capital sum to redeem in full or
                    partially any load for the building project others than loan
                    referred to the paragraph (k) subject to a maximum of 50% of
                    the total purchase money deposit in the Project Account.
                </Item>
            );
        case HousingRule.PARAGRAPH_5M:
            return (
                <Item className={className} marker="5(m).">
                    Any administrative expenses (including marketing and
                    advertising expenses) incurred on the building project
                    subject to maximum of 5% of the total cost of construction
                    of the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5N:
            return (
                <Item className={className} marker="5(n).">
                    The payment of good and services tax (GST) on the supply of
                    any goods and services to the licensed housing developer in
                    respect of the building project.
                </Item>
            );
        case HousingRule.PARAGRAPH_5O:
            return (
                <Item className={className} marker="5(o).">
                    Any forfeiture or refund of the moneys pursuant to the
                    provisions of the Executive Condominium Housing Scheme Act
                    (Cap. 99A).
                </Item>
            );
        default:
            return <></>;
    }
};

type ItemProps = {
    className?: string;
    marker: string;
    children: React.ReactNode;
};

const Item = ({ className = "", marker, children }: ItemProps): JSX.Element => {
    return (
        <div className={`position-relative ${className}`}>
            <Marker>{marker}</Marker>
            <span className="d-inline-block ms-6">{children}</span>
        </div>
    );
};

const Marker = styled.span`
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 3rem;
`;

type HousingRulesTextProps = {
    className?: string;
    rules: (HousingRule | string)[];
};

const HousingRulesText = ({
    className,
    rules,
}: HousingRulesTextProps): JSX.Element => {
    return (
        <>
            {[...rules].sort().map((it) => (
                <HousingRuleText
                    key={it}
                    className={`mb-3 ${className}`}
                    rule={it}
                />
            ))}
        </>
    );
};

export default HousingRulesText;
